<section class="w-full p-4">
    <div class="max-w-lg mx-auto space-y-6">
        @if (loadError()) {
            <div class="flex items-start gap-3 p-4 rounded-[4px] bg-red-50 border-l-4 border-l-red-500 text-red-800 text-sm">
                <svg class="size-5 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M15 9l-6 6m0-6l6 6"/>
                </svg>
                <p class="m-0">{{ loadError() }}</p>
            </div>
        }

        @if (serverError()) {
            <div class="flex items-start gap-3 p-4 rounded-[4px] bg-red-50 border-l-4 border-l-red-500 text-red-800 text-sm">
                <svg class="size-5 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M15 9l-6 6m0-6l6 6"/>
                </svg>
                <p class="m-0">{{ serverError() }}</p>
            </div>
        }

        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
            @if(userCanEdit()){
                <div>
                    <label for="beaconGroupId" class="block text-sm font-medium text-[#172C41] mb-1">Grupo</label>
                    <select
                        id="beaconGroupId"
                        formControlName="beaconGroupId"
                        class="w-full rounded-[4px] border px-3 py-2 text-sm focus:border-[#F99C1E] focus:ring-1 focus:ring-[#F99C1E] disabled:opacity-50 disabled:cursor-not-allowed"
                        [disabled]="!userCanEdit() || isLoading()"
                        [class.border-red-500]="fieldHasError('beaconGroupId')"
                        [class.border-gray-300]="!fieldHasError('beaconGroupId')"
                    >
                        <option [ngValue]="null">Seleccionar grupo</option>
                        @for (group of groupOptions(); track group.value) {
                            <option [ngValue]="group.value">{{ group.label }}</option>
                        }
                    </select>
                    @if (fieldHasError('beaconGroupId')) {
                        <p class="mt-1 text-sm text-red-600">{{ fieldError('beaconGroupId') }}</p>
                    }
                </div>
            } @else {
                <div class="text-gray-800">
                    Grupo: <b>{{ groupOptions().find(o => o.value == form.get('beaconGroupId')?.value)?.label }}</b>
                </div>
            }

            <div>
                <label for="holderName" class="block text-sm font-medium text-[#172C41] mb-1">Económico</label>
                <input
                    id="holderName"
                    type="text"
                    formControlName="holderName"
                    class="w-full rounded-[4px] border px-3 py-2 text-sm focus:border-[#F99C1E] focus:ring-1 focus:ring-[#F99C1E]"
                    [class.border-red-500]="fieldHasError('holderName')"
                    [class.border-gray-300]="!fieldHasError('holderName')"
                    placeholder="Nombre del titular"
                    [readonly]="!userCanEdit()"
                />
                @if (fieldHasError('holderName')) {
                    <p class="mt-1 text-sm text-red-600">{{ fieldError('holderName') }}</p>
                }
            </div>

            <div>
                <label for="assetName" class="block text-sm font-medium text-[#172C41] mb-1">Placas</label>
                <input
                    id="assetName"
                    type="text"
                    formControlName="assetName"
                    class="w-full rounded-[4px] border px-3 py-2 text-sm focus:border-[#F99C1E] focus:ring-1 focus:ring-[#F99C1E]"
                    [class.border-red-500]="fieldHasError('assetName')"
                    [class.border-gray-300]="!fieldHasError('assetName')"
                    placeholder="Nombre del activo"
                    [readonly]="!userCanEdit()"
                />
                @if (fieldHasError('assetName')) {
                    <p class="mt-1 text-sm text-red-600">{{ fieldError('assetName') }}</p>
                }
            </div>

            <div>
                <label for="vin" class="block text-sm font-medium text-[#172C41] mb-1">VIN</label>
                <input
                    id="vin"
                    type="text"
                    formControlName="vin"
                    class="w-full rounded-[4px] border px-3 py-2 text-sm focus:border-[#F99C1E] focus:ring-1 focus:ring-[#F99C1E]"
                    [class.border-red-500]="fieldHasError('vin')"
                    [class.border-gray-300]="!fieldHasError('vin')"
                    placeholder="VIN del vehículo (17 caracteres)"
                    [readonly]="!userCanEdit()"
                />
                @if (fieldHasError('vin')) {
                    <p class="mt-1 text-sm text-red-600">{{ fieldError('vin') }}</p>
                }
            </div>

            <div class="flex items-center gap-2">
                <input
                    id="trackingEnabled"
                    type="checkbox"
                    formControlName="trackingEnabled"
                    class="rounded-[4px] border-gray-300 text-[#F99C1E] focus:ring-[#F99C1E] focus:ring-1"
                />
                <label for="trackingEnabled" class="text-sm font-medium text-[#172C41]">Tracking habilitado</label>
            </div>

            <div class="flex items-center gap-4 pt-4 border-t border-gray-200">
                <button
                    type="button"
                    (click)="onCancel()"
                    class="inline-flex items-center gap-1 px-4 py-2 rounded-[4px] font-medium border border-[#172C41] text-[#172C41] cursor-pointer transition-colors text-sm hover:bg-gray-100"
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    [disabled]="isSaving()"
                    class="inline-flex items-center gap-1 px-4 py-2 rounded-[4px] font-medium bg-[#F99C1E] text-white cursor-pointer transition-colors text-sm hover:bg-[#e88c0e] disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    @if (isSaving()) {
                        Guardando...
                    } @else {
                        Guardar
                    }
                </button>
            </div>
        </form>
    </div>
</section>
